import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=70e69176&"
import script from "./HistoryPage.vue?vue&type=script&lang=js&"
export * from "./HistoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70e69176')) {
      api.createRecord('70e69176', component.options)
    } else {
      api.reload('70e69176', component.options)
    }
    module.hot.accept("./HistoryPage.vue?vue&type=template&id=70e69176&", function () {
      api.rerender('70e69176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/HistoryPage.vue"
export default component.exports